import { render } from "./AppTopBar.vue?vue&type=template&id=12a873e4&scoped=true"
import script from "./AppTopBar.vue?vue&type=script&lang=js"
export * from "./AppTopBar.vue?vue&type=script&lang=js"

import "./AppTopBar.vue?vue&type=style&index=0&id=12a873e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a873e4"]])

export default __exports__